module.exports = __webpack_public_path__ + "img/gorra.1a9501f8.webp";